import * as React from "react";
import { Divider, Form } from "semantic-ui-react";

import { Input } from "@neworbit/simpleui-input";

import { GPSpecialistInfo, GPSpecialistInfoType, GPSpecialistInfoTypeOptions } from "../models";

interface Props {
    model: GPSpecialistInfo;
    onChange: (model: GPSpecialistInfo) => void;
    showErrors: boolean;
}

export const WritableGPSpecialistInfoForm: React.FunctionComponent<Props> = ({ model, onChange, showErrors }: Props) => {

    const [infoModel, setInfoModel] = React.useState<GPSpecialistInfo>(model ?? {
        id: null,
        name: null,
        surgeryName: null,
        surgeryAddressAndPostcode: null,
        telephoneNumber: null,
        emailAddress: null,
        type: null,
    });

    React.useEffect(() => {
        if (infoModel) {
            onChange({ ...infoModel });
        }
    }, [onChange, infoModel]);

    const onNameChange = (name: string) => setInfoModel({ ...infoModel, name });

    const onSurgeryNameChange = (surgeryName: string) => setInfoModel({ ...infoModel, surgeryName });

    const onSurgeryAddressAndPostcodeChange = (surgeryAddressAndPostcode: string) =>
        setInfoModel({ ...infoModel, surgeryAddressAndPostcode });

    const onTelephoneNumberChange = (telephoneNumber: string) => setInfoModel({ ...infoModel, telephoneNumber });

    const onEmailChange = (emailAddress: string) => setInfoModel({ ...infoModel, emailAddress });

    const onTypeChange = (type: GPSpecialistInfoType) => setInfoModel({ ...infoModel, type });

    return (
        <Form>
            <Input.Textarea
                required
                label="Name"
                showErrors={showErrors}
                onChange={onNameChange}
                value={infoModel.name}
            />
            <Divider />
            <Input.Textarea
                required
                label="Surgery name"
                showErrors={showErrors}
                onChange={onSurgeryNameChange}
                value={infoModel.surgeryName}
            />
            <Divider />
            <Input.Textarea
                label="Surgery address &amp; postcode"
                showErrors={showErrors}
                onChange={onSurgeryAddressAndPostcodeChange}
                value={infoModel.surgeryAddressAndPostcode}
            />
            <Divider />
            <Input.Textarea
                label="Telephone number"
                showErrors={showErrors}
                onChange={onTelephoneNumberChange}
                value={infoModel.telephoneNumber}
            />
            <Divider />
            <Input.Textarea
                label="Email"
                showErrors={showErrors}
                onChange={onEmailChange}
                value={infoModel.emailAddress}
            />
            <Divider />
            <Input.Dropdown
                required
                label="Type"
                placeholder="Please select"
                showErrors={showErrors}
                onChange={onTypeChange}
                options={GPSpecialistInfoTypeOptions}
                value={infoModel.type}
            />
        </Form>
    );
};
